<style scoped lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/ruike/pending/receipt/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('dairukudanhao')">
            <el-input v-model="yt.conditions.no"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shengchanongdanhao')">
            <el-input v-model="yt.conditions.woNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('biaoqiantiaomahao')">
            <el-input v-model="yt.conditions.labelBarcodeNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')">
            <yi_cross_select multiple :component="'web_base_matter_list'" :ids.sync="yt.conditions.materialIds">
            </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('shenhezhuangtai')">
            <yi_dictionary_select :max="1" clearable="false" :type="'RUIKE_PENDING_RECEIPT_REVIEW_STATUS'" :ids.sync="yt.conditions.reviewStatus"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('kucunzuzhi')">
            <el-input v-model="yt.conditions.inventoryOrg"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chuangjianshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.startCreateTime" :end.sync="yt.conditions.endCreateTime">
            </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain :loading="yt.loading">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ startCreateTime: begin(), endCreateTime: end() });" :loading="yt.loading">{{ $t('chongzhi') }}
            </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('mingxi', scope.row, '70%')">
              {{ $t('mingxi') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="examine(scope.row)">
              {{ $t('shenhe') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="yt.exportLoading" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
    </yi_curd_table>
    <el-dialog v-dialog-drag :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <template v-if="yt.editObj.action == 'mingxi'">
        <div class="dialog-scroller">
          <receipt_details :receipt="yt.editObj"></receipt_details>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/customer/create')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import receipt_details from '@@/pages/web/production_management/pending_receipt_rk/receipt_details'
export default {
  name: 'web_production_management_pending_receipt_rk_list',
  components: {
    receipt_details
  },
  data() {
    return {
      rejectReason: '',
      goodInWorkshopLoading: false,
      goodInWarehouseLoading: false,
      badInWorkshopLoading: false,
      badInWarehouseLoading: false,
      rejectReportGoodQuantityLoading: false,
      list: [],
      ids: null,
      checkDisabled: true,
      totalExtend: {},
      columns: [
        {
          label: 'dairukudanhao',
          prop: 'no',
          // width: 130,
        }, {
          label: 'kucunzuzhi',
          prop: 'inventoryOrg',
          width: 130,
        }, {
          label: 'shenhezhuangtai',
          prop: 'reviewStatus',
          type: 'dictionary',
          key: 'RUIKE_PENDING_RECEIPT_REVIEW_STATUS',
          width: 130
        }, {
          label: 'shenheren',
          prop: 'reviewerObject.nickname',
          width: 130,
        }, {
          label: 'shenheshijian',
          prop: 'reviewTime',
          type: 'time',
          // format: 'YYYY-MM-DD',
          width: 180,
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 130,
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          // format: 'YYYY-MM-DD',
          width: 180,
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 180,
          fixed: 'right'
        }
      ],
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        //表格默认按提报时间降序排序。
        orderBy: 'createTime desc'
      }
      this.yt.get(1)
      // this.yt.get(1, this.beforeGet);
      this.$set(this.yt.conditions, 'startCreateTime', this.begin())
      this.$set(this.yt.conditions, 'endCreateTime', this.end())
    }, 300)

  },
  methods: {
    examine(value) {
      let params = {
        id: value.id
      }
      this.http.post('/custom/ruike/pending/receipt/review', params).then(res => {
        this.utils.successMessage(this.$t(res.msg));
        this.yt.get(1);
      }).catch(error => {
        this.utils.errorMessage(this.$t(error))
      })
    },
    beforeGet(params) {
      params['startCreateTime'] = this.begin()
      params['endCreateTime'] = this.end()
      return params
    },

    exportExcel() {
      let params = this.yt.conditions;
      this.yt.exportLoading = true;
      return this.http
        .get('/web/report/export/wode_pending_inventory_export', {
          params
        })
        .then(res => {
          this.$message.success(this.$t(res.msg));
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        })
        .finally(() => {
          this.yt.exportLoading = false;
        });
    },
    begin() {
      const date = new Date()
      const begin = (new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '01' +
        ' 00:00:00'))
        .getTime()
      return begin
    },
    end() {
      const date = new Date()
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const lastDay = new Date(year, month, 0).getDate();
      const end = (new Date(year, month - 1, lastDay, 23, 59, 59)).getTime()
      return end;
    },
    //入库仓库审核（良品）
    getGoodCheckInWarehouse() {
      this.goodInWarehouseLoading = true;
      let params = {
        ids: this.ids,
        inventoryType: 1
      }
      this.http.post('/custom/production/wode/pending/inventory/checkInWarehouse', params).then(res => {
        this.goodInWarehouseLoading = false;
        this.utils.successMessage(this.$t(res.msg));
        this.yt.get(1);
      }).catch(error => {
        this.goodInWarehouseLoading = false;
        this.utils.errorMessage(this.$t(error))
      })
    },
    //入库仓库审核（不良品）
    getBadCheckInWarehouse() {
      this.badInWarehouseLoading = true;
      let params = {
        ids: this.ids,
        inventoryType: 2
      }
      this.http.post('/custom/production/wode/pending/inventory/checkInWarehouse', params).then(res => {
        this.badInWarehouseLoading = false;
        this.utils.successMessage(this.$t(res.msg));
        this.yt.get(1);
      }).catch(error => {
        this.badInWarehouseLoading = false;
        this.utils.errorMessage(this.$t(error))
      })
    },
    //入库车间审核（良品）
    getGoodCheckInWorkshop() {
      this.goodInWorkshopLoading = true;
      let params = {
        ids: this.ids,
        inventoryType: 1
      }
      this.http.post('/custom/production/wode/pending/inventory/checkInWorkshop', params).then(res => {
        this.goodInWorkshopLoading = false;
        this.utils.successMessage(this.$t(res.msg));
        this.yt.get(1);
      }).catch(error => {
        this.goodInWorkshopLoading = false;
        this.utils.errorMessage(this.$t(error))
      })
    },
    //入库车间审核（不良品）
    getBadCheckInWorkshop() {
      this.badInWorkshopLoading = true;
      let params = {
        ids: this.ids,
        inventoryType: 2
      }
      this.http.post('/custom/production/wode/pending/inventory/checkInWorkshop', params).then(res => {
        this.badInWorkshopLoading = false;
        this.utils.successMessage(this.$t(res.msg));
        this.yt.get(1);
      }).catch(error => {
        this.badInWorkshopLoading = false;
        this.utils.errorMessage(this.$t(error))
      })
    },
    //良品入库驳回
    rejectReportGoodQuantity() {
      this.rejectReportGoodQuantityLoading = true;
      let params = {
        ids: this.ids,
        rejectReason: this.rejectReason
      }
      this.http.post('/custom/production/wode/pending/inventory/rejectReportGoodQuantity', params).then(res => {
        this.rejectReportGoodQuantityLoading = false;
        this.utils.successMessage(this.$t(res.msg));
        this.yt.get(1);
      }).catch(error => {
        this.rejectReportGoodQuantityLoading = false;
        this.utils.errorMessage(this.$t(error))
      })
    },

    // exportExcel() {
    //   let params = this.yt.conditions
    //   return this.http.get('/custom/report/page/dead_inventory_report', {
    //     params
    //   }).then(res => {
    //     this.$message.success(this.$t(res.msg))
    //     this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG')
    //   }).catch(error => {
    //     this.$message.error(this.$t(error))
    //   })
    // },
  },
};
</script>
